import CaseReviewFeatureFlagController from './CaseReviewFeatureFlagController'

export default CaseReviewFeatureFlagController
